import React from 'react'
import { Link } from 'react-router-dom'

// Lets Polaris components (Button url, Link url, ResourceItem url…) navigate with
// react-router inside the embedded app, while external URLs open in a new tab.
const AppLink = ({ children, url = '', external, target, ...rest }) => {
    if (external || /^(https?:)?\/\//.test(url) || url.startsWith('mailto:')) {
        return <a href={url} target={target ?? '_blank'} rel="noopener noreferrer" {...rest}>{children}</a>
    }
    return <Link to={url} {...rest}>{children}</Link>
}

export default AppLink
